/**
 * ALLDOQ launches the viewer with the archive token in the link (`?jwt=...`),
 * sometimes on the worklist and sometimes straight into a study
 * (`/viewer?StudyInstanceUIDs=...&jwt=...`). Every DICOMweb/WADO request reads
 * the token from sessionStorage `patientFilterData.radJwt`, but only the
 * WorkList route used to store it, so direct viewer links sent no
 * Authorization header at all.
 *
 * Runs once at startup, before the router, on every route: stores the token
 * where the loaders look for it (replacing any older one) and removes it from
 * the address bar so it does not stay in browser history.
 */
const STORAGE_KEY = 'patientFilterData';
const TOKEN_PARAMS = ['jwt', 'radJwt', 'radjwt'];

export default function captureRadJwt(win: Window = window): void {
  const searchParams = new URLSearchParams(win.location.search);
  const token = TOKEN_PARAMS.map(name => searchParams.get(name)).find(Boolean);

  if (!token) {
    return;
  }

  let stored = {};
  try {
    stored = JSON.parse(win.sessionStorage.getItem(STORAGE_KEY) || '{}') || {};
  } catch (e) {
    // Corrupt entry: start again rather than keep a token we cannot read.
  }

  try {
    win.sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ patientName: null, patientBirthDate: null, ...stored, radJwt: token })
    );
    if (JSON.parse(win.sessionStorage.getItem(STORAGE_KEY)).radJwt !== token) {
      return;
    }
  } catch (e) {
    // Same as WorkList: if storage is blocked, leave the URL alone.
    console.warn('Could not store the archive token in sessionStorage:', e);
    return;
  }

  TOKEN_PARAMS.forEach(name => searchParams.delete(name));
  const search = searchParams.toString();
  win.history.replaceState(
    win.history.state,
    '',
    `${win.location.pathname}${search ? `?${search}` : ''}${win.location.hash}`
  );
}
